// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../../../../graphql/api/index';

import { gql } from 'graphql-tag';
import { QuestionnaireStepFragmentDoc } from './QuestionnaireStep.fragment.generated';
import { QuestionnaireSignUpStepFragmentDoc } from './QuestionnaireSignUpStep.fragment.generated';
export const QuestionnaireFragmentDoc = gql`
    fragment questionnaire on Questionnaire {
  __typename
  id
  title
  type
  steps {
    ...questionnaireStep
  }
  signUpStep {
    ...questionnaireSignUpStep
  }
  requireLoginBeforeStarting
}
    ${QuestionnaireStepFragmentDoc}
${QuestionnaireSignUpStepFragmentDoc}`;